import React from 'react';
import './BarChartBar.scss';

export interface BarChartBarProps {
  widthPercent: number;
  className?: string;
  bgClassName?: string;
  children?: React.ReactNode;
}

export const BarChartBar: React.FC<BarChartBarProps> = ({ widthPercent, className = '', bgClassName = '', children }) => (
  <div className={`es-bar-container ${bgClassName}`.trim()}>
    <div className="es-bar-bg" />
    <div
      className={`es-bar ${className}`.trim()}
      // Keep 0 exactly if requested; otherwise ensure at least 2px to avoid html2canvas zero-size issues
      style={{ width: widthPercent === 0 ? '0px' : `max(${widthPercent}%, 2px)` }}
    >{children}</div>
  </div>
);

export default BarChartBar;
